export const CHARGES = 'COBROS'
export const CANCELLED_CHARGES = 'COBRO ANULADO'
export const STATUS_CANCELLED = 'cancelled'
export const STATUS_SEND = 'sent'
